import { requireService } from '@profgeosoft/di-ez';
import { Switch } from '@profgeosoft-ui/react';

import { wrap } from 'src/packages/mobx-di/wrap';

import type { GridRenderCellParams } from '@profgeosoft-ui/table';
import type { DirectoryRecord } from 'src/services/directory-service/entities/directory-record.entity';
import type { MainDirectoryService } from 'src/services/directory-service/main-directory-service';

type Props = {
  params: GridRenderCellParams<DirectoryRecord>;
  directory: MainDirectoryService;
};

export const StatusSwitcher = wrap<Props>(function StatusSwitcher({ params, directory }) {
  const { isEditing } = requireService('directoryPage');
  const record = directory.getRecordById(params.row.recordId);

  if (!record) {
    console.warn('record is not presented');
    return null;
  }

  const { recordsActivity, updateDirectoryStatus } = directory;
  const isChecked = record.recordChangeState === 'new' || !!recordsActivity[record.recordId];

  return (
    <Switch
      checked={isChecked}
      onChange={(value) => updateDirectoryStatus(value, params.row.recordId)}
      disabled={isEditing || params.row.recordChangeState === 'new'}
    />
  );
});
